import { TimeOff } from '../timeoff/timeoff.model';

export class UserProfile {
  public displayName: string;
  public jobTitle: string;
  public officeLocation: string;
  public email: string;
  public primaryPhone: string;
  public picture: string;
  public timeOffDates: TimeOff[];
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/userprofile/userprofile.model.ts